/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".banner[_ngcontent-%COMP%]{text-align:center;font-size:large;padding:150px;margin:15px;background-color:#ffcccb}\n/*# sourceMappingURL=jpm-maintenance.component.css.map*/"];
export { styles as styles };
